import type { ParseKeys, TFunction } from "i18next";

export type TranslationKey = ParseKeys;

export function tKey(key: string): TranslationKey {
  return key as TranslationKey;
}

// Matches a leftover, unsubstituted interpolation placeholder, e.g. "{{arg0}}".
const unresolvedPlaceholder = /\{\{.*?\}\}/;

// Interpolates a single positional value into a translation. The externally managed translation
// pipeline names its positional placeholder "arg0", and has changed that name before (it used to
// be "0"), so this falls back to substituting the value directly if it's left unresolved.
export function tPositional(t: TFunction, key: TranslationKey, value: string): string {
  // Pass undefined rather than "" for a blank value: some translations apply a format modifier
  // to the placeholder (e.g. "{{arg0,number}}"), and i18next's number formatter coerces "" to 0,
  // producing "0" instead of blank. An undefined arg0 leaves the placeholder unresolved instead,
  // which the fallback below then replaces with the blank value as intended.
  const result = t(key, { arg0: value || undefined }) as string;
  return unresolvedPlaceholder.test(result) ? result.replace(unresolvedPlaceholder, value) : result;
}
